import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Chapter = ({ index, label }) => (
  <div
    data-testid={`chapter-${index}`}
    className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-slate-400"
  >
    <span className="h-px w-8 bg-slate-300" />
    <span>
      {index} // {label}
    </span>
  </div>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);
